'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'radio-tuner';
var width = 512;
var height = 512;
var aliases = ["radio-alt"];
var unicode = 'f8d8';
var svgPathData = 'M32 160l0 64 448 0 0-64L32 160zM0 240l0-80 0-24 0-8 0-4.5 12.1-3 480-120 7.8 31L114 128l366 0 32 0 0 32 0 320 0 32-32 0L32 512 0 512l0-32L0 240zM32 480l448 0 0-224L32 256l0 224zM80 320l128 0 16 0 0 32-16 0L80 352l-16 0 0-32 16 0zm16 64l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm272-64a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRadioTuner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;